import { Routes, Route } from 'react-router-dom'
import { Layout } from './components/Layout'
import Home from './pages/Home'
import Services from './pages/Services'
import { Gallery } from './pages/Gallery'
import CaseStudies from './pages/CaseStudies'
import About from './pages/About'
import Referral from './pages/Referral'
import SmooveMove from './pages/case-studies/SmooveMove'
import GalaPay from './pages/case-studies/GalaPay'

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/services" element={<Services />} />
        <Route path="/portfolio" element={<Gallery />} />
        <Route path="/case-studies" element={<CaseStudies />} />
        <Route path="/about" element={<About />} />
        <Route path="/referral" element={<Referral />} />
        <Route path="/case-studies/smoove-move" element={<SmooveMove />} />
        <Route path="/case-studies/galapay" element={<GalaPay />} />
      </Routes>
    </Layout>
  )
}

export default App
